import React from 'react';
import withClickOutsideOnOverlay from '../../../hoc/withClickOutsideOnOverlay';
import cancelEvent from '../../../services/mini/cancelEvent';
import PopupWrapper from '../Popup/PopupWrapper';
import PopupHeader from '../Popup/PopupHeader';
import PopupBody from '../Popup/PopupBody';
import PopupButtons from '../Popup/PopupButtons';
import PopupButton from '../Popup/PopupButton';
import PopupCancelButton from '../Popup/PopupCancelButton';
import { popupHeaderIcons } from '../../../services/mini/popupHeaderIcons';
import _ from 'lodash';

class ConfirmPopup extends React.Component {

    componentDidMount() {
        document.addEventListener('keyup', this.handleHotKey, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.handleHotKey, false);
    }

    handleHotKey = (e) => {
        if (e.keyCode === 27) {
            this.props.onClose(e);
        }
        if (e.keyCode === 13) {
            this.props.okBtnCb(e);
        }
    }

    onExternalLayerClick = (e) => {
        const { externalLayerClass } = this.props;

        if (e.target.classList.contains(externalLayerClass)) {
            this.props.onClose(e);
        } else {
            cancelEvent(e);
        }
    }

    handleClickOutside = (e) => {
        this.props.onClose(e);
    }

    midBtnCb = () => {
        this.props.midBtnCb();
    }

    okCb = () => {
        this.props.okBtnCb();
    }

    cancelCb = () => {
        const { onClose } = this.props;
        onClose();
    }

    render() {
        const {
            title,
            message,
            okBtnLabel,
            cancelBtnLabel,
            externalLayerClass,
            midBtnLabel,
            midBtnCbClass,
            hideTitle,
            hideCancelBtn,
            midBtnWidth,
            okBtnWidth,
            type
        } = this.props;

        const content = <PopupWrapper className="confirm-popup">
            {!hideTitle && <PopupHeader
                title={title}
                titleIcon={type ? popupHeaderIcons[type] : null}
                onCancel={this.cancelCb} />}
            <PopupBody>
                {_.isString(message) ?
                    <div className={"confirm-popup_message"} dangerouslySetInnerHTML={{ __html: message }} /> :
                    <div className={"confirm-popup_message"}>
                        {message}
                    </div>
                }
                <PopupButtons>
                    {!hideCancelBtn && <PopupCancelButton label={cancelBtnLabel || 'Cancel'} action={this.cancelCb} />}
                    {midBtnLabel && <PopupButton label={midBtnLabel} action={this.midBtnCb} className={midBtnCbClass} width={midBtnWidth} />}
                    <PopupButton label={okBtnLabel || 'OK'} action={this.okCb} width={okBtnWidth} />
                </PopupButtons>
            </PopupBody>
        </PopupWrapper>;

        if (externalLayerClass) {
            return <div className={externalLayerClass} onClick={this.onExternalLayerClick}>
                {content}
            </div>;
        }

        return (content);
    }
}

export default withClickOutsideOnOverlay(ConfirmPopup);